import Repository from "./Repository";

export default {
    archiveChat (chatId) {
        return Repository.new().post("/archive-chat", {chatId: chatId});
    },
    unArchiveChat (chatId) {
        return Repository.new().post("/unArchive-chat", {chatId: chatId});
    },
    setInvoicePercentage (step, invoiceId) {
        return Repository.new().post("/invoice-progress-updated", {step: step, invoiceId: invoiceId});
    },
    getInvoiceById (invoice_id) {
        return Repository.new().get("/invoice", {invoice: invoice_id});
    },
    existEmail (emails) {
        return Repository.new().get("/email", {emails: emails});
    },
    registeredUser ( idsUsers) {
        return Repository.new().get("/registered-user", {ids: idsUsers});
    },
    getDecisionUser ( cif ) {
        return Repository.new().get("/get-decision", {cif: cif});
    },
    creatingResultInvoicesOld (factoringId) {
        return Repository.new().get("/creating-result-inv-old", {id: factoringId});
    },
    creatingResultInvoices (factoringId) {
        return Repository.new().get("/creating-result-inv", {id: factoringId});
    },
    updateAmount (invoice_id, amount) {
        return Repository.new().post("/update-amount", {invoice_id: invoice_id, amount: amount});
    },
    updatedueDate (invoice_id, dueDate) {
        return Repository.new().post("/update-due-date", {invoice_id: invoice_id, dueDate: dueDate});
    },
    updateDecision ( cif, decision ) {
        return Repository.new().post("/update-decision", {cif: cif, decision: decision});
    },
    updateInvoiceType (invoice_id, type) {
        return Repository.new().post("/update-invoice-type", {invoice_id: invoice_id, type: type});
    },
    isArchived (invoice_id, myCif) {
        return Repository.new().get("/is-archived", {invoice_id: invoice_id, myCif: myCif});
    },
    archivedInvoices (myCif) {
        return Repository.new().get("/archived-invoices", {myCif: myCif});
    },
    archivateInvoice (invoice_id, myCif) {
        return Repository.new().post("/archivate-invoice", {invoice_id: invoice_id, myCif: myCif});
    },
    unarchivateInvoice (invoice_id, myCif) {
        return Repository.new().post("/unarchivate-invoice", {invoice_id: invoice_id, myCif: myCif});
    },
    changeLanguage (lang) {
        return Repository.new().post("/change-language", {lang: lang});
    },
    getPayerComission () {
        return Repository.new().get("/payer-comission", {});
    },
    getFactorComission () {
        return Repository.new().get("/factor-comission", {});
    },
    getContacts (myCif) {
        return Repository.new().get("/get-contacts", {myCif: myCif});
    },
    addContact (myCif, contact) {
        return Repository.new().post("/add-contact", {myCif: myCif, contact: contact});
    },
    deleteContact (myCif, contact) {
        return Repository.new().post("/delete-contact", {myCif: myCif, contact: contact});
    },
    existContact (myCif, contact) {
        return Repository.new().get("/exist-contact", {myCif: myCif, contact: contact});
    },
    editContact (myCif, contact, oldCif) {
        return Repository.new().post("/edit-contact", {myCif: myCif, contact: contact, oldCif: oldCif});
    },
    uploadInvoice (myCif, otherCif, amount, type, date, number, files, factor, factorComission, payerComission, stars, account, dueDate) {
        return Repository.new().post("/upload-invoice", {myCif: myCif, otherCif: otherCif, amount: amount, type: type, date: date, number: number, files: files, factor: factor, factorComission: factorComission, payerComission: payerComission, stars: stars, accountNumber: account, dueDate: dueDate});
    },
    updateInvoice (id, Cif, otherCif, number, contactEmail, date, dueDate, accountNumber) {
        return Repository.new().post("/update-invoice", {id: id, cif: Cif, otherCif: otherCif, number: number, otherEmail: contactEmail, date: date, dueDate: dueDate, accountNumber: accountNumber});
    },
    updateInvoiceList (id, invoiceNumber, amount, receiverCif, payerCif, account, payerEmail, receiverEmail) {
        return Repository.new().post("/update-invoice-list", {id: id, invoiceNumber: invoiceNumber, amount: amount, receiverCif: receiverCif, payerCif: payerCif, account: account, payerEmail: payerEmail, receiverEmail: receiverEmail });
    },
    listInvoices (sent, received, showFactorings = false) {
        return Repository.new().post("/list-invoices", {sent: sent, received: received, showFactorings: showFactorings});
    },
    isInvited (idUser, idChat) {
        return Repository.new().get("/is-invited", {idUser: idUser, idChat: idChat});
    },
    isMember (idUser, idChat) {
        return Repository.new().get("/is-member", {idUser: idUser, idChat: idChat});
    },
    addNewMember (idUser, idChat) {
        return Repository.new().post("/add-new-member", {idUser: idUser, idChat: idChat});
    },
    getFactoringById ( id ) {
        return Repository.new().get("/get-factoring", {id: id});
    },
    getPlatformPublicAccounts () {
        return Repository.new().get("/platformPublicAccounts", {});
    },
    getPlatformAccounts () {
        return Repository.new().get("/platformAccounts", {});
    },
    addExchangeTransaction (type, amountPayed, amountReceive) {
        return Repository.new().post("/addExchangeTransaction", {type, amountPayed, amountReceive});
    },
    addExchangeTransactionToUser (user, type, amountPayed, amountReceive) {
        return Repository.new().post("/addExchangeTransactionToUser", {user, type, amountPayed, amountReceive});
    },
    updateFactoring (factoring_id, new_status) {
        return Repository.new().post("/update-factoring", {id: factoring_id, status: new_status});
    },
    hideFactoring (factoring_id) {
        return Repository.new().post("/hide-factoring", {id: factoring_id});
    },
    invoicePayed (invoice_id) {
        return Repository.new().post("/invoice-payed", {id: invoice_id});
    },
    invoicePayedOutsidePlatform(invoice_id){
        return Repository.new().post("/invoice-payed-outside-platform", {id: invoice_id});
    },
    hideInvoice (invoice_id) {
        return Repository.new().post("/hide-invoice", {id: invoice_id});
    },
    getUserById (id) {
        return Repository.new().get("/get-user", {id: id});
    },
    setFactoring (me, idFactoring, idChat) {
        return Repository.new().post("/set-factoring", {me, idFactoring, idChat});
    },
    acceptByppayFromUser (id, acceptedPaymentMethods, acceptByppayes, factoring) {
        return Repository.new().post("/accept-byppay-from", {id, acceptedPaymentMethods, acceptByppayes, factoring});
    },
    declineByppays (id, declineAllByppasses, factoring) {
        return Repository.new().post("/decline-byppay-from", {id, declineAllByppasses, factoring});
    },
    addFunds (address) {
        return Repository.new().post("/add-funds", {address});
    },
    isAcceptingByppayFromUser (user, otherUser) {
        return Repository.new().get("/is-accepting-byppay-and-crypto-from-user", {user: user, otherUser: otherUser});
    },
    existUserStripe (cif) {
        return Repository.new().get("/exist-user-stripe", {cif: cif});
    },
    acceptBank (cif) {
        return Repository.new().get("/accept-bank", {cif: cif});
    },
    getUsersInfo (cif) {
        return Repository.new().get("/get-users-info", {cif: cif});
    },
    getUserByCif (cif) {
        return Repository.new().get("/get-user_by_cif", {cif: cif});
    },
    invoiceAcceptPayment (invoice_id) {
        return Repository.new().post("/invoice-accept-payment", {id: invoice_id});
    },
    saveUser (cif, name, surname, phone, email, address, country, newRole, id, payerComission, receiverComission, platformComission, stripePublicKey, stripePrivateKey, walletAddress, iban, percentageInvoicePayer, percentageInvoiceReceiver, userCommision, platformCommision, platformWalletAddress, platformStripePublic, platformStripePrivate, eurToBytoRatio) {
        return Repository.new().post("/save-user", {cif: cif, name: name, surname: surname, phone: phone, email: email, address: address, country: country, role: newRole, id: id, payerComission: payerComission, receiverComission: receiverComission, platformComission: platformComission, stripePublicKey: stripePublicKey, stripePrivateKey: stripePrivateKey, walletAddress: walletAddress,iban: iban, percentageInvoicePayer: percentageInvoicePayer, percentageInvoiceReceiver: percentageInvoiceReceiver, userCommision: userCommision, platformCommision: platformCommision, platformWalletAddress, platformStripePublic, platformStripePrivate, eurToBytoRatio});
    },
    saveParameters (payerComission, receiverComission, platformComission, factorComission, stripePublicKey, stripePrivateKey, walletAddress, iban, percentageInvoicePayer, percentageInvoiceReceiver, userCommission, platformCommission, platformWalletAddress, platformStripePublic, platformStripePrivate, eurToBytoRatio) {
        return Repository.new().post("/save-parametes", {payerComission: payerComission, receiverComission: receiverComission, platformComission: platformComission, factorComission: factorComission, stripePublicKey: stripePublicKey, stripePrivateKey: stripePrivateKey, walletAddress: walletAddress, iban: iban, percentageInvoicePayer: percentageInvoicePayer, percentageInvoiceReceiver: percentageInvoiceReceiver, userCommission: userCommission, platformCommission: platformCommission, platformWalletAddress, platformStripePublic, platformStripePrivate, eurToBytoRatio});
    },
    getInvoiceSC (id) {
        return Repository.new().get("/invoice-sc", {id: id});
    },
    saveFiles (files) {
        return Repository.new().postFile("/save-file", {files: files});
    },
    saveVideo (video) {
        return Repository.new().postVideo("/save-video", {files: [video]});
    },
    getUserPhones ( id ) {
        return Repository.new().get("/get-phone-factoring", {id: id});
    },
    getFilename ( id ) {
        return Repository.new().get("/get-filename", {id: id});
    },
    getChatFile ( id ) {
        return Repository.new().get("/get-chat-filename", {id: id});
    },
    updateEmailUser ( id, email ) {
        return Repository.new().post("/update-user", {id: id, email: email});
    },
    getParameters () {
        return Repository.new().get("/parameters", {});
    },
    getParametersMarket () {
        return Repository.new().get("/parametersMarket", {});
    },
    changeStatus (id, status) {
        return Repository.new().post("/change_offerStatus", {id: id, status: status});
    },
    getInvoicesInformation (sent, received) {
        return Repository.new().post("/invoices-information", {sent: sent, received: received});
    },
    getNoChatInvoicesInformation (sent, received) {
        return Repository.new().post("/no-chat-invoices-information", {sent: sent, received: received});
    },
    getChatsInformation () {
        return Repository.new().get("/chats-information", {});
    },
    getInvoiceChat (chat) {
        return Repository.new().get("/invoice-chat-information", {invoiceId: chat.invoiceId});
    },
    getChatFromInvoice (idInvoice) {
        return Repository.new().get("/get-chat-from-invoice", {idInvoice: idInvoice});
    },
    getChat (idChat) {
        return Repository.new().get("/get-chat", {idChat: idChat});
    },
    getMessagesFromChat (idChat) {
        return Repository.new().get("/get-messages-from-chat", {idChat});
    },
    getAllByppaysToAddMarket () {
        return Repository.new().get("/invoices-market", {});
    },
    createBypay (invoiceAB, invoiceBC, option, video, acceptedPaymentMethods) {
        return Repository.new().post("/create-bypay", {invoiceAB: invoiceAB._id, invoiceBC: invoiceBC._id, option: option, video: video, acceptedPaymentMethods});
    },
    addBypayToChat (idChat, idBypay) {
        return Repository.new().post("/add-bypay-to-chat", {idChat, idBypay});
    },
    notify (factoring, onlyMe = false) {
        return Repository.new().get("/notify-partners", {factoring: factoring, onlyMe: onlyMe});
    },
    remind (factId) {
        return Repository.new().post("/remind", {factoring: factId});
    },
    savePublic (myFile) {
        return Repository.new().postImage("/save-public", myFile);
    },
    saveDbImage (file) {
        return Repository.new().post('/save-db-image', {file: {name: file.name, size: file.size, type: file.type}});
    },
    createInvoicePhoto (id, num, amount, cifOther, facCom, facPay, Pay, Rec, date, dueDate, mailOther) {
        return Repository.new().post("/create-inv-data", {id: id, num: num, amount: amount, cifOther: cifOther, facCom: facCom, facPay: facPay, pay: Pay, rec: Rec, date: date, dueDate: dueDate, mailOther: mailOther});
    },
    createChat (me, mode) {
        return Repository.new().post("/create-chat", {me, mode});
    },
    setSecondUser (me, idChat) {
        return Repository.new().post("/set-second-user", {me: me, idChat: idChat});
    },
    setFactoringUser (me, idChat) {
        return Repository.new().post("/set-factoring-user", {me: me, idChat: idChat});
    },
    unsetFactoringUser (idChat) {
        return Repository.new().post("/unset-factoring-user", {idChat: idChat});
    },
    setPaymentMethods (me, idChat, stripePublic, stripePrivate, walletAddress, bankAccount) {
        return Repository.new().post("/set-payment-methods", {me: me, idChat: idChat, stripePublic: stripePublic, stripePrivate: stripePrivate, walletAddress: walletAddress, bankAccount: bankAccount});
    },
    sendFile (me, idChat, text, fileName) {
        return Repository.new().post("/send-file", {me: me, idChat: idChat, text: text, fileName: fileName});
    },
    payChat (me, idChat) {
        return Repository.new().post("/pay-chat", {me: me, idChat: idChat});
    },
    sendMessage (me, idChat, text, tag = null) {
        return Repository.new().post("/send-message", {me: me, idChat: idChat, text: text, tag: tag});
    },
    getMessage (idMessage) {
        return Repository.new().get('/get-message', {idMessage: idMessage});
    },
    payerPaymentToReceiverUpdate (idFactoring, newStatus, me) {
        return Repository.new().post("/payer-payment-to-receiver-update", {idFactoring: idFactoring, newStatus: newStatus, me});
    },
    generateRectifyingInvoice (idChat) {
        return Repository.new().post("/generate-rectifying-invoice", {idChat: idChat});
    },
    generateNewInvoice (idChat) {
        return Repository.new().post("/generate-new-invoice", {idChat: idChat});
    },
    generateInvoiceStamp(idChat){
        return Repository.new().post("/generate-invoice-stamp", {idChat: idChat});
    },
    generateNewCertification (idChat) {
        return Repository.new().post("/generate-new-certification", {idChat: idChat});
    },
    generateByppayAgreement (idChat) {
        return Repository.new().post("/generate-byppay-agreement", {idChat: idChat});
    },
    generateByppayContract (idChat) {
        return Repository.new().post("/generate-byppay-contract", {idChat: idChat});
    },
    payerPaymentToPlatformUpdate (idFactoring, newStatus, me, aAcceptReceiveBytos = false) {
        return Repository.new().post("/payer-payment-to-platform-update", {idFactoring: idFactoring, newStatus: newStatus, me, aAcceptReceiveBytos});
    },
    middlePaymentToReceiverUpdate (idFactoring, newStatus) {
        return Repository.new().post("/middle-payment-to-receiver-update", {idFactoring: idFactoring, newStatus: newStatus});
    },
    middlePaymentToPlatformUpdate (idFactoring, newStatus) {
        return Repository.new().post("/middle-payment-to-platform-update", {idFactoring: idFactoring, newStatus: newStatus});
    },
    payerPaymentToMiddleUpdate (idFactoring, newStatus) {
        return Repository.new().post("/payer-payment-to-middle-update", {idFactoring: idFactoring, newStatus: newStatus});
    },
    paymentIntent ( amount, user, chatId = null ) {
        return Repository.new().post("/create-payment-intent", {amount: amount, user: user, chatId: chatId});
    },
    getNotifications () {
        return Repository.new().get("/notifications", {});
    },
    getExangeRatios () {
        return Repository.new().get("/exangeRatios", {});
    },
    getRemainingTransactions () {
        return Repository.new().get("/remainingTransactions", {});
    },
    updateTransaction (id) {
        return Repository.new().post("/updateTransaction", {id});
    },
    setNotifications ( from, to, msg, url) {
        return Repository.new().post("/notifications", {from: from, to: to, msg: msg, url: url});
    },
    setMarketItem (idFactoring, name, percentage, emails) {
        return Repository.new().post("/marketItem", {idFactoring: idFactoring, name: name, percentage: percentage, emails: emails});
    },
    deleteItemMarket (idFactoring) {
        return Repository.new().post("/deleteMarketItem", {idFactoring: idFactoring});
    },
    getMarketItem (idFactoring) {
        return Repository.new().get("/marketItem", {idFactoring: idFactoring});
    },
    getMarketItems () {
        return Repository.new().get("/marketItems", {});
    },
    closeMarketItem (idFactoring) {
        return Repository.new().post("/closeMarketItem", {idFactoring: idFactoring});
    },
    getMyCollaterals () {
        return Repository.new().get("/getMyCollaterals", {});
    },
    addCollateral (idFactoring, amount, typeAmount, acceptReceiveBytos) {
        return Repository.new().post("/addCollateral", {idFactoring, amount, typeAmount, acceptReceiveBytos});
    },
    addCollateralBlockchain (idFactoring, amount, acceptReceiveBytos) {
        return Repository.new().post("/addCollateralBlockchain", {idFactoring, amount, acceptReceiveBytos});
    },
    getCollateral (idCollateral) {
        return Repository.new().get("/getCollateral", {idCollateral});
    },
    getCollateralsByFactoringId (idFactoring) {
        return Repository.new().get("/getCollateralsByFactoringId", {idFactoring});
    },
    getCollateralsNotPayedByFactoringId (idFactoring) {
        return Repository.new().get("/getCollateralsNotPayedByFactoringId", {idFactoring});
    },
    getUserStripe () {
        return Repository.new().get("/user-stripe", {});
    },
    updateUserStripe (stripePublickey, stripePrivateKey) {
        return Repository.new().post("/user-stripe", {stripePublickey, stripePrivateKey});
    },
    updateUserWallet (walletAddress) {
        return Repository.new().post("/update-user-wallet", {walletAddress});
    },
    addPayment (payer, receiver, type, amount, idTransaction, idByppay, collateral) {
        return Repository.new().post("/addPayment", {payer, receiver, type, amount, idTransaction, idByppay, collateral });
    },
    addInvoiceMarketItem (walletAddress, idFactoring, amount, ACclc, percentage) {
        return Repository.new().post("/addInvoiceMarketItem", {walletAddress, idFactoring, amount, ACclc, percentage });
    },
    payCollateralStripe (idFactoring, index) {
        return Repository.new().post("/payCollateralStripe", {idFactoring, index });
    },
    inviteChat (idChat, user, inviteMethod, mail, isPayer = false) {
        return Repository.new().post("/invite-chat", {idChat, user, inviteMethod, mail, isPayer });
    },
    inviteChatA (invoiceId, idChat, inviteMethod, mail) {
        return Repository.new().post("/invite-chat-a", {invoiceId, idChat, inviteMethod, mail });
    },
    remindMail (idChat, idUser, inviteMethod, mail, message, subject, view, isPayer = false) {
        return Repository.new().post("/remind-mail", {idChat, idUser, inviteMethod, mail, message, subject, view, isPayer});
    },
    getAllChatFiles (idChat) {
        return Repository.new().get("/get-all-chat-files", {idChat});
    },
    addInvoiceToChat (idChat, idInvoice) {
        return Repository.new().post("/add-invoice-to-chat", {idChat, idInvoice});
    },
    messageHelp(idChat){
        return Repository.new().post("/message-help", {idChat});
    },
    getFactoringByInvoice (invoice) {
        return Repository.new().get("/get-factoring-from-invoice", {invoice});
    },
    getInvoiceImage (invoice) {
        return Repository.new().get("/get-invoice-image", {invoice});
    },
    getExtraMessageSystem(messageTag, language){
        return Repository.new().get("/extraMessageSystem", {messageTag, language});
    },
    setExtraMessageSystem(tag, language, values){
        return Repository.new().post("/extraMessageSystem", {tag, language, values});
    },
    fetchTags(){
        return Repository.new().get("/tags", {});
    },
    getMyNotifications () {
        return Repository.new().get("/getMyNotifications", {});
    },
    updateNotifications () {
        return Repository.new().post("/updateMyNotifications", {});
    },
    readMessages (unread, idChat) {
        return Repository.new().post("/messages-unread", {unread: unread, idChat: idChat});
    },
};
